<template>
  <div class="reminders-page flex-1 flex-col flex">
    <div class="reminders-hero bg-primary text-white">
      <div class="hero-row">
        <div>
          <p class="hero-eyebrow">Fleet Management</p>
          <h3 class="hero-title">Maintenance Reminders</h3>
        </div>
        <div class="hero-count-card">
          <p class="hero-count">{{ unreadNotif2 }}</p>
          <p class="hero-count-label">Unread</p>
        </div>
      </div>
    </div>

    <div class="reminders-list-wrap flex-1">
      <div class="list-toolbar">
        <div class="toolbar-left">
          <span class="toolbar-title">Reminders</span>
          <span class="toolbar-subtitle">Page {{ currentPage }} / {{ totalPages }}</span>
        </div>
        <vs-button
          size="small"
          type="border"
          color="primary"
          :disabled="unreadNotif2 <= 0"
          @click="markAllAsRead"
        >
          Mark all as read
        </vs-button>
      </div>

      <ul class="reminders-list">
        <li
          v-for="ntf in paginatedReminders"
          :key="ntf.idx"
          class="reminder-item"
          @click="navigateToStockAlert(ntf.idx, ntf.readStatus)"
        >
          <div class="reminder-left">
            <div class="reminder-icon-wrap">
              <feather-icon
                icon="ClockIcon"
                :svgClasses="['stroke-current h-5 w-5 text-warning']"
              ></feather-icon>
            </div>
            <div class="reminder-content">
              <span
                class="font-medium block reminder-title"
                :class="[`text-${ntf.category}`]"
                >{{ ntf.title }}</span
              >
              <small
                v-if="Number(ntf.readStatus) === 0"
                class="read-badge"
                >Unread</small
              >
              <small class="reminder-message">{{ ntf.msg }}</small>
            </div>
          </div>
          <div class="reminder-right">
            <small class="reminder-time">{{ ntf.create_time }}</small>
            <vs-button
              v-if="Number(ntf.readStatus) === 0"
              size="small"
              type="flat"
              icon="done"
              color="success"
              @click.stop="markOneAsRead(ntf.idx)"
            >
              Mark read
            </vs-button>
          </div>
        </li>
      </ul>

      <div v-if="!unreadNotifications2 || unreadNotifications2.length === 0" class="empty-state">
        <feather-icon
          icon="CalendarIcon"
          :svgClasses="['stroke-current h-10 w-10 text-grey']"
        ></feather-icon>
        <p class="empty-title">No unread reminders</p>
        <p class="empty-subtitle">Scheduled maintenance reminders will show here.</p>
      </div>

      <div v-if="unreadNotifications2 && unreadNotifications2.length > 0" class="pagination-wrap">
        <vs-button
          size="small"
          type="border"
          color="primary"
          :disabled="currentPage <= 1"
          @click="currentPage = currentPage - 1"
        >
          Previous
        </vs-button>
        <span class="pagination-text">{{ currentPage }} / {{ totalPages }}</span>
        <vs-button
          size="small"
          type="border"
          color="primary"
          :disabled="currentPage >= totalPages"
          @click="currentPage = currentPage + 1"
        >
          Next
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem('userInfo')),
      unreadNotif2: Number(localStorage.getItem('unreadNotif2') || 0),
      unreadNotifications2: JSON.parse(localStorage.getItem('unreadNotifications2') || '[]'),
      currentPage: 1,
      pageSize: 10,
    };
  },
  computed: {
    totalPages() {
      const count = Array.isArray(this.unreadNotifications2)
        ? this.unreadNotifications2.length
        : 0;
      return Math.max(1, Math.ceil(count / this.pageSize));
    },
    paginatedReminders() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return (this.unreadNotifications2 || []).slice(start, end);
    },
  },
  mounted() {
    this.refreshReminders();
  },
  methods: {
    async refreshReminders() {
      try {
        const response = await this.$http.get(
          `personals/notifications/${this.userInfo.uid}`,
        );
        const payload = response && response.data ? response.data : {};
        this.unreadNotifications2 = Array.isArray(payload.allNotifications2)
          ? payload.allNotifications2.map((x) => ({
              ...x,
              readStatus: Number(x.readStatus || 0),
            }))
          : [];
        this.unreadNotif2 = this.unreadNotifications2.filter(
          (x) => Number(x.readStatus) === 0,
        ).length;

        localStorage.setItem('unreadNotif2', this.unreadNotif2);
        localStorage.setItem(
          'unreadNotifications2',
          JSON.stringify(this.unreadNotifications2),
        );
      } catch (_error) {}
    },
    markOneAsRead(idx) {
      this.unreadNotifications2 = (this.unreadNotifications2 || []).map((item) =>
        item.idx === idx ? { ...item, readStatus: 1 } : item,
      );
      this.unreadNotif2 = this.unreadNotifications2.filter(
        (x) => Number(x.readStatus) === 0,
      ).length;
      localStorage.setItem('unreadNotif2', this.unreadNotif2);
      localStorage.setItem(
        'unreadNotifications2',
        JSON.stringify(this.unreadNotifications2),
      );
    },
    async markAllAsRead() {
      try {
        await this.$http.patch(`personals/fms_notifications/${this.userInfo.uid}`);
      } catch (_error) {}
      this.unreadNotifications2 = (this.unreadNotifications2 || []).map((item) => ({
        ...item,
        readStatus: 1,
      }));
      this.unreadNotif2 = 0;
      localStorage.setItem('unreadNotif2', this.unreadNotif2);
      localStorage.setItem(
        'unreadNotifications2',
        JSON.stringify(this.unreadNotifications2),
      );
    },
  },
};
</script>

<style scoped>
.reminders-page {
  background: #f7f8fc;
}

.reminders-hero {
  padding: 18px 20px;
  border-radius: 12px;
  margin: 14px;
  box-shadow: 0 8px 24px rgba(22, 55, 122, 0.2);
}

.hero-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hero-eyebrow {
  font-size: 12px;
  opacity: 0.8;
  margin-bottom: 4px;
}

.hero-title {
  color: #fff;
  margin: 0;
}

.hero-count-card {
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 10px;
  min-width: 88px;
  text-align: center;
  padding: 8px 12px;
}

.hero-count {
  font-size: 20px;
  font-weight: 700;
  margin: 0;
  color: #fff;
}

.hero-count-label {
  font-size: 11px;
  margin: 0;
  opacity: 0.85;
}

.reminders-list-wrap {
  margin: 0 14px 14px;
  overflow: auto;
}

.list-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.toolbar-left {
  display: flex;
  flex-direction: column;
}

.toolbar-title {
  font-size: 14px;
  font-weight: 600;
  color: #2d3550;
}

.toolbar-subtitle {
  font-size: 12px;
  color: #8891a7;
}

.reminders-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.reminder-item {
  background: #fff;
  border: 1px solid #ebeef4;
  border-radius: 10px;
  padding: 14px 16px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  cursor: pointer;
  transition: box-shadow 0.2s ease;
}

.reminder-item:hover {
  box-shadow: 0 6px 20px rgba(27, 45, 94, 0.08);
}

.reminder-left {
  display: flex;
  align-items: flex-start;
  flex: 1;
}

.reminder-icon-wrap {
  background: #fff7e8;
  border-radius: 9999px;
  padding: 8px;
  margin-right: 10px;
}

.reminder-content {
  min-width: 0;
}

.read-badge {
  display: inline-block;
  margin-top: 5px;
  margin-bottom: 2px;
  padding: 2px 8px;
  border-radius: 9999px;
  background: #fff0d6;
  color: #b46a00;
  font-size: 11px;
  font-weight: 600;
}

.reminder-message {
  color: #59627a;
  display: block;
  margin-top: 4px;
}

.reminder-time {
  color: #8f97ab;
  margin-left: 10px;
  white-space: nowrap;
}

.reminder-right {
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 6px;
}

.empty-state {
  margin-top: 24px;
  text-align: center;
  color: #7d8497;
}

.empty-title {
  margin-top: 8px;
  font-weight: 600;
}

.empty-subtitle {
  font-size: 12px;
  opacity: 0.85;
}

.pagination-wrap {
  margin-top: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.pagination-text {
  font-size: 12px;
  color: #6f7890;
  min-width: 56px;
  text-align: center;
}
</style>
